<main class="bg-white position-relative">
  <div class="payoutt_container">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-6 O-M-2">
          <div class="title_content">
            <h1 class="text-uppercase text-white open_sans font_68 bold_700">cart</h1>
            <p class="mt-lg-3 mt-xl-4 mt-2">On Payouttt, every sneaker you want is always available and
              authentic.</p>
            <div class="mt-lg-3 mt-xl-4">
              <a
                class="text-uppercase open_sans bold_700 text-white bg_green shop_btn d-inline-block font_16 mt-lg-2 mt-xl-3"
                routerLink="/categories-detail">Shop
                Now</a>
            </div>
          </div>
        </div>
        <div class="col-md-6 O-M-1 text-right">
          <img alt="" class="img-fluid" src="/assets/images/categories-shoes.png"/>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>

  <!-- cart table -->
  <section class="product-table-sec padd-top-bot">
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <div class="table-responsive">
            <table class="display product-detail-table">
              <thead>
              <tr>
                <th>Product</th>
                <th>Sneaker</th>
                <th>SKU</th>
                <th>Size</th>
                <th class="qty-sec">qty</th>
                <th>Bid price</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td><img alt="" src=".//assets/images/cart-product-img.png"></td>
                <td class="sneaker-sec">
                  <p>Off-White x Wmns Air Zoom Terra Kiger 5 (W)-Athlete in Progress(Electric
                    Green) </p>
                </td>
                <td>CD8179-300</td>
                <td>86</td>
                <td class="qty-sec">
                  <div class="quantity-sec-top" id="field1">
                    <button class="add" id="add" type="button"><i aria-hidden="true"
                                                                  class="fa fa-angle-down"></i></button>
                    <input max="30" min="1" type="number" value="1"/>
                    <button class="sub" id="sub" type="button"><i aria-hidden="true"
                                                                  class="fa fa-angle-up"></i></button>
                  </div>
                </td>
                <td>
                  $222.00
                </td>
                <td><a href="javascript:void(0)"><i aria-hidden="true"
                                                    class="fa fa-trash"></i></a></td>
              </tr>
              <tr>
                <td><img alt="" src=".//assets/images/cart-product-img.png"></td>
                <td class="sneaker-sec">
                  <p>Off-White x Wmns Air Zoom Terra Kiger 5 (W)-Athlete in Progress(Electric
                    Green) </p>
                </td>
                <td>CD8179-300</td>
                <td>86</td>
                <td class="qty-sec">
                  <div class="quantity-sec-top" id="field2">
                    <button class="add" id="add2" type="button"><i aria-hidden="true"
                                                                   class="fa fa-angle-down"></i></button>
                    <input max="30" min="1" type="number" value="1"/>
                    <button class="sub" id="sub2" type="button"><i aria-hidden="true"
                                                                   class="fa fa-angle-up"></i></button>
                  </div>
                </td>
                <td>
                  $222.00
                </td>
                <td><a href="javascript:void(0)"><i aria-hidden="true"
                                                    class="fa fa-trash"></i></a></td>
              </tr>
              <tr>
                <td><img alt="" src=".//assets/images/cart-product-img.png"></td>
                <td class="sneaker-sec">
                  <p>Off-White x Wmns Air Zoom Terra Kiger 5 (W)-Athlete in Progress(Electric
                    Green) </p>
                </td>
                <td>CD8179-300</td>
                <td>86</td>
                <td class="qty-sec">
                  <div class="quantity-sec-top" id="field3">
                    <button class="add" id="add3" type="button"><i aria-hidden="true"
                                                                   class="fa fa-angle-down"></i></button>
                    <input max="30" min="1" type="number" value="1"/>
                    <button class="sub" id="sub3" type="button"><i aria-hidden="true"
                                                                   class="fa fa-angle-up"></i></button>
                  </div>
                </td>
                <td>
                  $222.00
                </td>
                <td><a href="javascript:void(0)"><i aria-hidden="true"
                                                    class="fa fa-trash"></i></a></td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="cart-totale-sec">
            <div class="inner-cart-totale">
              <h2>CART TOTALS</h2>
              <div class="sub-total-sec padd-top-bot-25">
                <h3>Subtotal</h3>
                <h3>$222.00</h3>
              </div>
              <div class="shipping-sec padd-top-bot-25">
                <h3>Shipping</h3>
                <div class="shipping-radio-sec">
                  <div class="custom-control custom-radio">
                    <input class="custom-control-input" id="customRadioInline1" name="customRadioInline1"
                           type="radio">
                    <label class="custom-control-label" for="customRadioInline1">Flat Rate:
                      $100.00</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input class="custom-control-input" id="customRadioInline2" name="customRadioInline1"
                           type="radio">
                    <label class="custom-control-label" for="customRadioInline2">Free
                      Shipping</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input class="custom-control-input" id="customRadioInline3" name="customRadioInline1"
                           type="radio">
                    <label class="custom-control-label" for="customRadioInline3">International
                      Delivery: $170.00</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input class="custom-control-input" id="customRadioInline4" name="customRadioInline1"
                           type="radio">
                    <label class="custom-control-label" for="customRadioInline4">Local Delivery:
                      $60.00</label>
                  </div>
                  <div class="custom-control custom-radio">
                    <input class="custom-control-input" id="customRadioInline5" name="customRadioInline1"
                           type="radio">
                    <label class="custom-control-label" for="customRadioInline5">Local Pickup
                      (Free)</label>
                  </div>
                </div>
              </div>
              <div class="myaccordion calculate-shipping-sec">
                <div class="brand-header">
                  <h3>Calculate Shipping</h3>
                  <span class="mines-plus-circle">
                                            <i aria-hidden="true" class="fa fa-angle-down"></i>
                                        </span>
                </div>
                <div class="inner-accordion">
                  <div class="sub-total-sec padd-top-bot-25 total-sec">
                    <h3>SUBTOTAL</h3>
                    <h3>$222.00</h3>
                  </div>
                  <div class="sub-total-sec padd-top-bot-25 total-sec">
                    <h3>SUBTOTAL</h3>
                    <h3>$222.00</h3>
                  </div>
                  <div class="sub-total-sec padd-top-bot-25 total-sec">
                    <h3>SUBTOTAL</h3>
                    <h3>$222.00</h3>
                  </div>
                </div>
              </div>
              <div class="sub-total-sec padd-top-bot-25 total-sec">
                <h3>TOTAL</h3>
                <h3><b>$222.00</b></h3>
              </div>
            </div>
            <div class="proceed-checkout-btn">
              <a routerLink="/checkout">PROCEED TO CHECKOUT</a>
            </div>
          </div>

          <div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
